import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { nafColor } from '@nafcore/theme';
import { breakpoints, spacing } from '@naf/theme';
import { Button } from '@naf-simba/elements-buttons';

export const TopBar = styled.div<{
  $isMenuOpen: boolean;
}>`
  display: flex;
  padding: ${spacing.space16} ${spacing.space24};
  border-radius: ${spacing.space8};
  border: 1px solid ${nafColor.signature.yellow20};
  backdrop-filter: blur(7.5px);
  -webkit-backdrop-filter: blur(7.5px);
  height: 38px;
  margin-top: ${spacing.space16};
  background-color: ${({ $isMenuOpen }) => {
    if ($isMenuOpen) {
      return nafColor?.signature.yellow10 || '#FFFAEC';
    }
    return 'rgba(255, 250, 236, 0.8)';
  }};

  ${({ $isMenuOpen }) =>
    $isMenuOpen &&
    css`
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom: 0;
    `}

  @media (max-width: ${breakpoints.l}) {
    display: none;
  }
`;

export const SearchbarContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const TopBarItems = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  justify-content: flex-start;

  @media (max-width: ${breakpoints.l}) {
    align-self: stretch;
    display: none;
  }
`;

export const ExtraNavbarLinks = styled.div`
  display: flex;

  @media (width <= 1270px) {
    display: none;
  }
`;

export const CustomerField = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;

  .naf-ButtonLabel {
    font-size: 1rem;
  }
`;

export const NavigationButtonsWrapper = styled.div`
  display: flex;

  .naf-ButtonLabel {
    font-size: 1rem;
  }

  @media (width <= 1060px) {
    [data-hide-at-compact-navbar='true'] {
      display: none;
    }
  }
`;

export const SearchButton = styled(Button)`
  && {
    background-color: transparent;

    .naf-ButtonLabel {
      font-size: 1rem;
    }

    &:hover {
      background-color: ${nafColor.signature.yellow40};
    }
  }
`;

export const LoaderWrapper = styled.div`
  margin: 0 ${spacing.space16};
`;
